/**
 * 重置密码
 * 2017-12-6
 */
"use strict";
angular.module("fresetPasswordModule", []).controller("fresetPasswordCtrl", ['$scope', '$element', '$validation', '$state', 'httpService', '$q','modalDialog', function ($scope, $element, $validation, $state, httpService, $q,modalDialog) {
	initStatus();
	initData();

	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {};
		$scope.data = {
			listData: [],
			same: false, //判断密码是否一致
		};
		$scope.page = {};
	}

	/**
	 * [initStatus description] 初始化数据
	 */
	function initData() {
		loadEncryptionLib().then(function () {
			encryptionMethods();
		});
	}

	/**
	 * [regularIf description] 判断是否显示正确图标
	 * @return {[type]} [description]
	 */
	$scope.regularIf = function (key, value) {
		switch (key) {
			case 2: //登录密码
				$scope.isShowTipsB = false;
				$scope.data.isShowTipsBb = false;
				var passwordLength = $element.find('.table>ul>li:nth-child(2)>.tips');
				passwordLength.text().length > 8 ? passwordLength.addClass('notPaddintTop') : passwordLength.removeClass('notPaddintTop');
				// $scope.data.minPassword = false;
				break;
			case 3: //确认密码
				$scope.isShowTipsC = false;
				$scope.data.isShowTipsCc = false;
				$scope.data.same = false;
				var reallyPassword = $element.find('.table>ul>li:nth-child(3)>.tips');
				reallyPassword.text().length > 8 ? reallyPassword.addClass('notPaddintTop') : reallyPassword.removeClass('notPaddintTop');
				break;
		}
		$validation.validate($scope.basicInformation[value]).success(function () {
			switch (key) {
				case 2:
					if ($scope.status.modes > 1) {
						$scope.data.isShowTipsBb = true;
					}
					if (!$scope.info.confirmPassword) return;
					if ($scope.info.password != $scope.info.confirmPassword) {
						$scope.data.same = true;
						$scope.data.isShowTipsCc = false;
					} else {
						$scope.data.same = false;
						$scope.data.isShowTipsCc = true;
					}
					break;
				case 3:
					if ($scope.info.password != $scope.info.confirmPassword) {
						$scope.data.same = true;
						$scope.data.isShowTipsCc = false;
					} else {
						$scope.data.same = false;
						$scope.data.isShowTipsCc = true;
					}
					break;
			}
		});

	};

	/**
	 * [confirm description] 确认
	 * @return {[type]} [description]
	 */
	$scope.confirm = function () {
		if ($scope.data.isShowTipsCc && !$scope.isShowTipsC) {
			let params = {
				password: $scope.info.password,
				confirmPassword: $scope.info.confirmPassword
			};
			params.password = encryptedString(bodyRSA(), params.password);
			params.confirmPassword = encryptedString(bodyRSA(), params.confirmPassword);
			httpService.http('/mcnww/web/user/resetMobileUserPwd.do', params, 'post').then(function (data) {
				if (data.success) {
					$state.go('forgetpassword.resetsuccess');
				} else {
					modalDialog.success(data.message, " ", false, function () {
					}, function () {
					}, '');
				}
			});
		} else {
			return;
		}
	}

	/**
	 * [encryptionMethods description] 加密方法
	 * @return {[type]} [description]
	 */
	function encryptionMethods() {
		$.ajax({
			url: "/mcnadmin/web/user/publicKey.do",
			dataType: "text",
			success: function (data) {
				$("#encryption").remove();
				$("body").append("<script id='encryption'>" + data + "</script>");
			}
		});
	}

	/**
	 * [loadEncryptionLib description] 加载加密依赖文件
	 * @return {[type]} [description]
	 */
	function loadEncryptionLib() {
		var deffer = $q.defer();
		LazyLoad.js(["static/rsa/RSA.js", "static/rsa/BigInt.js", "static/rsa/Barrett.js"], function () {
			deffer.resolve();
		});
		return deffer.promise;
	}
}]);
